import * as Immutable from "immutable";
import { ValidationError } from "../types/types";

export const hasPath = (errors: Immutable.List<ValidationError>, path: string):boolean => {
  return errors && errors.some(x => x.path === path);
}

export const forPath = (errors: Immutable.List<ValidationError>, path: string): ValidationError => {
  return errors.find(x => x.path === path);
}